import { createStore } from '~/store/createStore'

export const usePageWinner98Store = createStore<{
  strategyType: number
}>(() => {
  return { strategyType: 1 }
})
